import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.user.detail');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-user-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.user.detail/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminUserDetailComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public userId: string = '';
    public user: any = null;
    public xpStats: any = null;
    public summary: any = null;
    public loading: boolean = true;

    public tab: string = 'overview';
    public get tabs() {
        return [
            { key: 'overview', label: this.t.admin_tab_overview },
            { key: 'progress', label: this.t.admin_progress },
            { key: 'xp', label: this.t.admin_tab_xp },
            { key: 'quiz', label: this.t.admin_tab_quizzes },
            { key: 'game', label: this.t.admin_tab_games },
            { key: 'review', label: this.t.admin_tab_review },
            { key: 'manage', label: this.t.admin_tab_manage },
        ];
    }

    // Tab data
    public progressList: any[] = [];
    public progressLoaded: boolean = false;

    public xpHistory: any[] = [];
    public xpTotal: number = 0;
    public xpPage: number = 1;
    public xpFilter: string = '';
    public xpLoaded: boolean = false;

    public quizHistory: any[] = [];
    public quizLoaded: boolean = false;

    public gameHistory: any[] = [];
    public gameLoaded: boolean = false;

    public reviewWords: any[] = [];
    public reviewFilter: string = '';
    public reviewLoaded: boolean = false;

    public tabLoading: boolean = false;

    private routerSub: any;
    private langListener: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        this.userId = WizRoute.segment.id;
        if (this.userId) {
            await this.loadDetail();
        }
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newId = WizRoute.segment.id;
                if (newId && newId !== this.userId) {
                    this.userId = newId;
                    this.resetTabData();
                    await this.loadDetail();
                }
            }
        });
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    private resetTabData() {
        this.progressLoaded = false;
        this.xpLoaded = false;
        this.quizLoaded = false;
        this.gameLoaded = false;
        this.reviewLoaded = false;
        this.progressList = [];
        this.xpHistory = [];
        this.quizHistory = [];
        this.gameHistory = [];
        this.reviewWords = [];
    }

    public async loadDetail() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("detail", { user_id: this.userId });
        if (code === 200) {
            this.user = data.user;
            this.xpStats = data.xp_stats;
            this.summary = data.summary;
        }
        this.loading = false;
        await this.service.render();
    }

    public async switchTab(key: string) {
        if (this.tab === key) return;
        this.tab = key;
        await this.service.render();
        await this.loadTabData(key);
    }

    public async loadTabData(key: string) {
        if (key === 'progress' && !this.progressLoaded) {
            this.tabLoading = true;
            await this.service.render();
            const { code, data } = await wiz.call("progress_list", { user_id: this.userId });
            if (code === 200) this.progressList = data || [];
            this.progressLoaded = true;
            this.tabLoading = false;
            await this.service.render();
        }
        if (key === 'xp' && !this.xpLoaded) {
            await this.loadXpHistory();
        }
        if (key === 'quiz' && !this.quizLoaded) {
            this.tabLoading = true;
            await this.service.render();
            const { code, data } = await wiz.call("quiz_history", { user_id: this.userId });
            if (code === 200) this.quizHistory = data || [];
            this.quizLoaded = true;
            this.tabLoading = false;
            await this.service.render();
        }
        if (key === 'game' && !this.gameLoaded) {
            this.tabLoading = true;
            await this.service.render();
            const { code, data } = await wiz.call("game_history", { user_id: this.userId });
            if (code === 200) this.gameHistory = data || [];
            this.gameLoaded = true;
            this.tabLoading = false;
            await this.service.render();
        }
        if (key === 'review' && !this.reviewLoaded) {
            await this.loadReviewWords();
        }
    }

    public async loadXpHistory() {
        this.tabLoading = true;
        await this.service.render();
        const params: any = { user_id: this.userId, page: this.xpPage };
        if (this.xpFilter) params.activity_type = this.xpFilter;
        const { code, data } = await wiz.call("xp_history", params);
        if (code === 200) {
            this.xpHistory = data.data || data || [];
            this.xpTotal = data.total || 0;
        }
        this.xpLoaded = true;
        this.tabLoading = false;
        await this.service.render();
    }

    public async onXpFilterChange() {
        this.xpPage = 1;
        this.xpLoaded = false;
        await this.loadXpHistory();
    }

    public async onXpPageChange(page: number) {
        this.xpPage = page;
        this.xpLoaded = false;
        await this.loadXpHistory();
    }

    public async loadReviewWords() {
        this.tabLoading = true;
        await this.service.render();
        const params: any = { user_id: this.userId };
        if (this.reviewFilter) params.filter = this.reviewFilter;
        const { code, data } = await wiz.call("review_words", params);
        if (code === 200) this.reviewWords = data || [];
        this.reviewLoaded = true;
        this.tabLoading = false;
        await this.service.render();
    }

    public async onReviewFilterChange() {
        this.reviewLoaded = false;
        await this.loadReviewWords();
    }

    // Data management
    public confirmText: string = '';
    public confirmAction: string = '';
    public confirmTarget: string = '';
    public showConfirmModal: boolean = false;
    public confirmImpact: string = '';

    public async resetProgress() {
        // Show impact preview first
        const { code: sc, data: sd } = await wiz.call("impact_preview", { user_id: this.userId, action: "reset_progress" });
        const impact = sc === 200 ? sd.impact : '';
        this.confirmAction = 'reset_progress';
        this.confirmTarget = 'RESET';
        this.confirmText = '';
        this.confirmImpact = impact;
        this.showConfirmModal = true;
        await this.service.render();
    }

    public async recalcXp() {
        const { code: sc, data: sd } = await wiz.call("impact_preview", { user_id: this.userId, action: "recalc_xp" });
        const impact = sc === 200 ? sd.impact : '';
        this.confirmAction = 'recalc_xp';
        this.confirmTarget = 'RECALC';
        this.confirmText = '';
        this.confirmImpact = impact;
        this.showConfirmModal = true;
        await this.service.render();
    }

    public async executeConfirmedAction() {
        if (this.confirmText !== this.confirmTarget) return;
        this.showConfirmModal = false;

        if (this.confirmAction === 'reset_progress') {
            const { code, data } = await wiz.call("reset_progress", { user_id: this.userId, confirm: "yes" });
            if (code === 200) {
                await this.service.alert.show({ title: 'Готово (완료)', message: `Удалено записей (삭제된 기록): ${data.deleted}`, action: 'OK' });
                this.resetTabData();
                await this.loadDetail();
            }
        } else if (this.confirmAction === 'recalc_xp') {
            const { code, data } = await wiz.call("recalc_xp", { user_id: this.userId });
            if (code === 200) {
                await this.service.alert.show({ title: 'Готово (완료)', message: `XP: ${data.total_xp}, Уровень (레벨): ${data.star_level} (записей/기록: ${data.records})`, action: 'OK' });
                await this.loadDetail();
            }
        }
        this.confirmText = '';
        await this.service.render();
    }

    public closeConfirmModal() {
        this.showConfirmModal = false;
        this.confirmText = '';
        this.service.render();
    }

    public async cleanupOrphans() {
        // First scan
        const { code: sc, data: sd } = await wiz.call("cleanup_orphans", { user_id: this.userId, mode: "scan" });
        if (sc !== 200) return;
        if (sd.count === 0) {
            await this.service.alert.show({ title: 'Результат (결과)', message: 'Нет лишних записей. (불필요한 기록이 없습니다.)', action: 'OK' });
            return;
        }
        const res = await this.service.alert.show({
            title: 'Найдены лишние записи (불필요한 기록 발견)',
            message: `Найдено ${sd.count} записей для несуществующих уроков. Удалить? (존재하지 않는 레슨 기록 ${sd.count}건. 삭제할까요?)`,
            action: 'Удалить (삭제)',
            actionBtn: 'error',
            cancel: 'Отмена (취소)'
        });
        if (!res) return;
        const { code, data } = await wiz.call("cleanup_orphans", { user_id: this.userId, mode: "delete" });
        if (code === 200) {
            await this.service.alert.show({ title: 'Готово (완료)', message: `Удалено (삭제): ${data.count}`, action: 'OK' });
            this.resetTabData();
            await this.loadDetail();
        }
    }

    // Helpers
    public goBack() {
        this.service.href('/admin/users');
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('ru-RU', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch { return dateStr; }
    }

    public formatDateTime(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('ru-RU', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        } catch { return dateStr; }
    }

    public statusBadge(status: string): string {
        if (status === 'completed') return 'text-emerald-700 bg-emerald-50 ring-emerald-600/20';
        if (status === 'in_progress') return 'text-amber-700 bg-amber-50 ring-amber-600/20';
        return 'text-gray-700 bg-gray-50 ring-gray-600/20';
    }

    public statusLabel(status: string): string {
        if (status === 'completed') return 'Завершён';
        if (status === 'in_progress') return 'В процессе';
        return 'Не начат';
    }

    public activityLabel(type: string): string {
        const map: any = { lesson: 'Урок (레슨)', quiz: 'Тест (퀴즈)', review: 'Повторение', game: 'Игра (게임)' };
        return map[type] || type;
    }

    public activityBadge(type: string): string {
        const map: any = {
            lesson: 'text-blue-700 bg-blue-50 ring-blue-600/20',
            quiz: 'text-purple-700 bg-purple-50 ring-purple-600/20',
            review: 'text-amber-700 bg-amber-50 ring-amber-600/20',
            game: 'text-emerald-700 bg-emerald-50 ring-emerald-600/20',
        };
        return map[type] || 'text-gray-700 bg-gray-50 ring-gray-600/20';
    }

    public difficultyLabel(d: string): string {
        const map: any = { easy: 'Лёгкий', normal: 'Средний', hard: 'Сложный' };
        return map[d] || d;
    }

    public gameTypeLabel(t: string): string {
        const map: any = { word_search: 'Поиск слов', crossword: 'Кроссворд' };
        return map[t] || t;
    }

    public quizTypeLabel(t: string): string {
        const map: any = { choice: 'Выбор', listening: 'Аудирование', speaking: 'Говорение' };
        return map[t] || t;
    }

    public accuracyColor(acc: number): string {
        if (acc >= 90) return 'text-emerald-700 bg-emerald-50';
        if (acc >= 70) return 'text-amber-700 bg-amber-50';
        return 'text-red-700 bg-red-50';
    }

    public formatTime(seconds: number): string {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s.toString().padStart(2, '0')}`;
    }

    public xpBreakdownPct(breakdown: any): any {
        if (!breakdown) return {};
        const total = Object.values(breakdown).reduce((a: number, b: any) => a + (b as number), 0) as number;
        if (total === 0) return { lesson: 0, quiz: 0, review: 0, game: 0 };
        return {
            lesson: Math.round((breakdown.lesson || 0) / total * 100),
            quiz: Math.round((breakdown.quiz || 0) / total * 100),
            review: Math.round((breakdown.review || 0) / total * 100),
            game: Math.round((breakdown.game || 0) / total * 100),
        };
    }
}

export default PageAdminUserDetailComponent;